"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination_1 = require("./Pagination");
Object.defineProperty(exports, "Pagination", { enumerable: true, get: function () { return Pagination_1.Pagination; } });
//# sourceMappingURL=index.js.map